import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/CSC/CENTURY_SPRING_RGB_PRIMARY_LOGO_AW.png';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { List, ListItem } from './components/misc';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLineForPart, QuoteLineForServices } from './components/QuoteLine';
import { PartDescription } from './components/QuoteLine/PartDescription';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

const CSC_SITE_INFORMATION = [
  '5959 Triumph Street',
  'Commerce CA 90040',
  'Phone (800) 237-5225',
  'Fax 213-749-8569',
];

export function CSCQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo source={logo} extraStyles={[{ height: '42px' }]} />

        <SiteInformation
          name="Century Spring Corp. / MW Ind."
          items={CSC_SITE_INFORMATION}
        />

        <QuoteId ecommerceUri="https://www.centuryspring.com" />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation />
      </QuoteDetails>

      {quoteLines.map((line) => {
        const { part, ...lineProps } = line;
        if (!part) {
          return <QuoteLineForServices {...line} showDescription />;
        }

        return (
          <QuoteLineForPart
            key={line.id}
            {...lineProps}
            part={part}
            showDrawing
          >
            <PartId part={part} showCustomerPartId />

            <PartDescription description={part.description} />
            {part.partSpecs && <PartSpecs specs={part.partSpecs} />}
            <PartSpecs specs={line.specs} />
          </QuoteLineForPart>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={styles.row}>
        <View style={[styles.fullRow, styles.textSmall]}>
          <Text style={styles.bold}>
            Thank you for your interest in our items. Please review the
            following terms and conditions:
          </Text>
          <Text>{'\n'}</Text>
          <List>
            <ListItem>
              These items are manufactured in the USA and quoted to catalog
              specifications within S.M.I. tolerances only.
            </ListItem>
            <ListItem>
              Prices are valid for 30 days from the date of quotation.
            </ListItem>
            <ListItem>
              Our order minimum is $25.00. Orders below this amount will incur a
              $15.00 small order fee.
            </ListItem>
            <ListItem>
              Parts are in stock unless otherwise noted and can ship
              immediately.
            </ListItem>
            <ListItem>
              Only a standard Certificate of Conformance (C of C) is provided
              for catalog items.
            </ListItem>
            <ListItem>
              FAIR, DFAR, traceability, or material certifications will not be
              provided.
            </ListItem>
            <ListItem>
              Orders over $1,000 are considered NCNR (Non-Cancellable,
              Non-Returnable).
            </ListItem>
            <ListItem>
              Payment terms are Net 30 upon approved credit; otherwise, payment
              is required in advance via credit card. We accept all major credit
              cards
            </ListItem>
            <ListItem>
              Freight charges are calculated at the time of shipment.
            </ListItem>
            <ListItem>
              A 20% restocking fee applies to all returns made within 30 days of
              delivery (with a valid authorization number).
            </ListItem>
          </List>
        </View>
      </View>
    </Page>
  );
}
